import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { VocabulaireTerm } from '@vip/shared';
import { api } from '../../lib/apiClient';

export interface Vocabulaire {
  versie: number;
  termen: VocabulaireTerm[];
}

export function useVocabulaire() {
  return useQuery({
    queryKey: ['vocabulaire'],
    queryFn: () => api.get<Vocabulaire>('/admin/vocabulaire'),
  });
}

export function useBewaarVocabulaire() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (invoer: { termen: VocabulaireTerm[]; changeNote: string }) =>
      api.post<{ versie: number; aantal: number }>('/admin/vocabulaire', invoer),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['vocabulaire'] }),
  });
}
